import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import butterflyLogo from '../../assets/logo_1.png';
import bgImage from '../../assets/bgimg2.png';

const WelnessAboutUs = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  return (
    <div>
      {/* Hero Section */}
      <section  data-aos="fade-right" className="relative bg-gradient-to-r from-[#00847C] to-[#5CCEC4] text-white overflow-hidden px-4 sm:px-8 md:px-12 py-8 sm:py-12">
        {/* Background Image with 40% Transparency */}
        <div
          className="absolute inset-0 bg-cover bg-center z-0"
          style={{ backgroundImage: `url(${bgImage})` }}
        ></div>

        {/* Content Wrapper */}
        <div className="relative z-10 max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12 items-center">
          
          {/* Left Side Text */}
          <div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6">
              ABOUT US
            </h2>
            <p className="text-sm sm:text-base md:text-lg leading-relaxed mb-4 sm:mb-6 text-white/90">
              Butterfly Wellness is more than a clinic—it's a space of transformation. 
              Founded by Dr. Deepika, a respected psychologist, healer, and transformation coach, 
              our center integrates modern psychology with soulful healing to support people 
              through every stage of life. Whether you're dealing with anxiety, stress, grief, trauma, 
              parenting struggles, or life transitions, we're here to walk alongside you. 
              We create a safe, nurturing environment where healing begins and growth becomes natural.
            </p>
            <a
              href="https://wa.me/919952753900"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full sm:w-auto px-4 sm:px-6 py-3 bg-[#005CA8] text-white font-semibold rounded hover:opacity-90 transition inline-block text-center"
            >
              Start Your Healing Journey
            </a>

          </div>

          {/* Right Side Image */}
          <div className="flex justify-center md:justify-end mt-6 md:mt-0">
            <img
              src={butterflyLogo}
              alt="Butterfly Logo"
              className="w-56 sm:w-72 md:w-96"
            />
          </div>
        </div>
      </section>

      {/* Philosophy Section */}
      <section  data-aos="fade-up" className="pt-8 sm:pt-12 bg-white text-center px-4 sm:px-8 md:px-12">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 sm:mb-6 uppercase">
          Our Philosophy: Whole-Person Healing
        </h2>

        <p className="max-w-xl sm:max-w-2xl mx-auto text-gray-600 mb-6 sm:mb-12 text-sm sm:text-base">
          At Butterfly Wellness, we understand that wellness is not one-size-fits-all. 
          Our approach is holistic—addressing mind, body, emotions, and energy. 
          Every session is rooted in empathy, guided by evidence-based therapies, 
          and customized to your unique story.
        </p>

        <p className="max-w-xl sm:max-w-2xl mx-auto text-gray-600 mb-6 sm:mb-12 text-sm sm:text-base">
          Our goal is not just to manage symptoms but to help you feel truly 
          <span className="font-bold"> seen</span>, 
          <span className="font-bold"> heard</span>, and 
          <span className="font-bold"> empowered</span>—so you can live a life aligned 
          with your authentic self.
        </p>
      </section>
    </div>
  );
};

export default WelnessAboutUs;
